import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { FormLabel, FormCodeInput, FormFeedback } from '../form';
import { PrimaryButton } from '../buttons';
import { DIARY_PIN_SIZE } from './index';

import './DiaryResetPin.scss';

const DiaryResetPin = ({ 
  onSubmit, 
  isLoading = false,
  showSuccessMessage = false, 
  showFailureMessage = false 
}) => {
  const { t } = useTranslation();

  return (
    <div className="diary-reset-pin">
      <div className="page-header">
        <h1>{t('diaryReset.title')}</h1>
      </div>

      {/* Class name matches your SCSS: .diary-reset-pin-container.container */}
      <div className="diary-reset-pin-container container">
        {showSuccessMessage ? (
          <div className="diary-reset-pin-success">
            <h2>{t('diaryReset.successTitle')}</h2>
            <p>{t('diaryReset.successDescription')}</p>
            
            <NavLink to="/diary">
              <PrimaryButton
                label={t('diaryReset.goToDiary')}
                type="button"
                colorScheme="green"
              />
            </NavLink>
          </div>
        ) : (
          <Form 
            onSubmit={onSubmit}
            initialValues={{ pin: '' }}
            render={({ handleSubmit, values, invalid, submitting }) => {
              const pinVal = values.pin || '';
              
              // Button unlocks only when exactly 4 digits are entered
              const isButtonLocked = 
                isLoading || 
                submitting || 
                invalid || 
                pinVal.length < DIARY_PIN_SIZE;

              return (
                <form className="diary-reset-pin__form" onSubmit={handleSubmit} noValidate>
                  <FormLabel>{t('diaryReset.pin')}</FormLabel>
                  
                  <FormCodeInput 
                    name="pin" 
                    fields={DIARY_PIN_SIZE} 
                    type="tel" 
                  />

                  {showFailureMessage && (
                    <div className="diary-reset-pin-failure">
                      <FormFeedback positive={false}>
                        {t('diaryReset.failure')}
                      </FormFeedback>
                    </div>
                  )}

                  <div className="diary-reset-pin__actions">
                    <PrimaryButton 
                      label={t('diaryReset.reset')} 
                      type="submit" 
                      disabled={isButtonLocked}
                      loading={isLoading || submitting}
                    />
                  </div>
                </form>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

DiaryResetPin.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  showSuccessMessage: PropTypes.bool,
  showFailureMessage: PropTypes.bool
};

export default DiaryResetPin;
